import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { useFunctionalRef } from '@wix/da-hooks/pkg/useFunctionalRef';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import LazyLoadingImage from '../../LazyLoadingImage';
import AvatarPlaceholder from '../AvatarPlaceholder';
import s from './AvatarImage.scss';
const MAX_PIXELATED_RESOLUTION = 50;
function isSmallGifImage(img) {
    if (!img.src) {
        return false;
    }
    let imgExtension = img.src.split('?').shift();
    if (!imgExtension) {
        return false;
    }
    imgExtension = imgExtension.split('.').pop();
    return imgExtension === 'gif' && img.naturalHeight <= MAX_PIXELATED_RESOLUTION && img.naturalWidth <= MAX_PIXELATED_RESOLUTION;
}
const AvatarImage = (_param)=>{
    var { isGroup, enableLazyLoad } = _param, imgProps = _object_without_properties(_param, [
        "isGroup",
        "enableLazyLoad"
    ]);
    const [shouldBePixelated, setPixelated] = useState(false);
    const [imgRef, setRef] = useFunctionalRef(null);
    const onLoad = useCallback(()=>{
        if (imgRef.current && isSmallGifImage(imgRef.current)) {
            setPixelated(true);
        }
    }, [
        imgRef
    ]);
    const props = _object_spread_props(_object_spread({}, imgProps), {
        className: classnames(s['user-avatar'], shouldBePixelated && s['pixelated'], imgProps.className),
        onLoad
    });
    if (!imgProps.src) {
        return /*#__PURE__*/ React.createElement(AvatarPlaceholder, {
            isGroup: isGroup,
            width: imgProps.width,
            height: imgProps.height,
            className: imgProps.className,
            "aria-hidden": imgProps['aria-hidden']
        });
    }
    if (!enableLazyLoad) {
        // eslint-disable-next-line jsx-a11y/alt-text
        return /*#__PURE__*/ React.createElement("img", _object_spread({
            loading: "lazy",
            "data-hook": BiDataHook.USER_AVATAR
        }, props));
    }
    return /*#__PURE__*/ React.createElement(LazyLoadingImage, _object_spread({
        "data-hook": BiDataHook.USER_AVATAR,
        innerRef: setRef
    }, props));
};
AvatarImage.displayName = 'AvatarImage';
export default AvatarImage;
